import { LazyImport, LazyModule } from 'owa-bundling-light';
import type * as lazyIndex from './lazyIndex';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "HeaderMicrosoft365Upsell" */ './lazyIndex'),
    { name: 'HeaderMicrosoft365Upsell' }
);

export const lazyFetchMicrosoft365UpgradeEligibility: LazyImport<
    typeof lazyIndex.fetchMicrosoft365UpgradeEligibility,
    typeof lazyModule
> = new LazyImport(lazyModule, module => module.fetchMicrosoft365UpgradeEligibility);

export const lazyGetMicrosoft365UpgradeTier: LazyImport<
    typeof lazyIndex.getMicrosoft365UpgradeTier,
    typeof lazyModule
> = new LazyImport(lazyModule, module => module.getMicrosoft365UpgradeTier);
